<header>
  <div class="header-inner">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="sidebar_logo">
            <a routerLink="/">
              <img src="assets/images/logo.png" class="img-fluid" alt="logo" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
